/* eslint-disable jsx-a11y/label-has-associated-control */
import { Row, Select, Spin, Table } from 'antd';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
//import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { homeStatisticsService } from 'config/services';

import { HttpError } from 'helpers/http';
import './styles.css';

import {
  HomeStatisticsOptions,
  HomeStats,
  MostReadOptions,
  MostRead,
  PendingArticlesCountStats,
  TodaysCountStats,
  AnalyticsCount,
} from 'types/services/homeStatistics';

import { GroupedColumn } from './GroupedColumn';
import { PieChart } from './Pie';
import { transformResource } from './utils';

export const Home = () => {
  const { Column } = Table;
  const { t } = useTranslation();
  const [dateFrom, setDateFrom] = useState(new Date().toISOString().substring(0, 10) + ' 00:00:00');
  const [dateTo, setDateTo] = useState(() => {
    const current = new Date();
    current.setHours(current.getHours() - current.getTimezoneOffset() / 60);
    return current.toISOString().substring(0, 19).replace('T', ' ');
  });
  const [readDateFrom, setReadDateFrom] = useState(() => {
    let current = new Date();
    current.setHours(current.getHours() - current.getTimezoneOffset() / 60);
    current.setHours(current.getHours() - 1);
    return current.toISOString().substring(0, 19).replace('T', ' ');
  });
  const [readDateTo, setReadDateTo] = useState(() => {
    const current = new Date();
    current.setHours(current.getHours() - current.getTimezoneOffset() / 60);
    return current.toISOString().substring(0, 19).replace('T', ' ');
  });
  const [buttonValue, setButtonValue] = useState('');

  const [filters, setFilters] = useState<HomeStatisticsOptions>({ dateFrom: dateFrom, dateTo: dateTo });
  const [readFilters, setReadFilters] = useState<MostReadOptions>({
    readDateFrom: readDateFrom,
    readDateTo: readDateTo,
    category: buttonValue,
  });

  const btnEnu = ['sve', 'vijesti', 'sport', 'showbiz', 'lifestyle', 'sci-tech'];
  const [btn, setBtn] = useState(btnEnu[0]);

  const { Option } = Select;

  useEffect(() => {
    setFilters({ dateFrom: dateFrom, dateTo: dateTo });
  }, [dateFrom, dateTo]);

  useEffect(() => {
    setReadFilters({ readDateFrom: readDateFrom, readDateTo: readDateTo, category: buttonValue });
  }, [readDateFrom, readDateTo, buttonValue]);

  const onDateChange = (value: any) => {
    const current = new Date();
    current.setHours(current.getHours() - current.getTimezoneOffset() / 60);
    if (value === 'today') {
      setDateFrom(current.toISOString().substring(0, 10) + ' 00:00:00');
      setDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    } else if (value === 'yesterday') {
      current.setDate(current.getDate() - 1);
      setDateFrom(current.toISOString().substring(0, 10) + ' 00:00:00');
      setDateTo(current.toISOString().substring(0, 10) + ' 23:59:59');
    } else if (value === 'lastWeek') {
      const currentFrom = new Date();
      currentFrom.setDate(current.getDate() - 7);
      setDateFrom(currentFrom.toISOString().substring(0, 10) + ' 00:00:00');
      setDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    } else if (value === 'lastMonth') {
      const currentFrom = new Date();
      currentFrom.setDate(current.getDate() - 30);
      setDateFrom(currentFrom.toISOString().substring(0, 10) + ' 00:00:00');
      setDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    }
  };

  const onReadDateChange = (value: any) => {
    const current = new Date();
    current.setHours(current.getHours() - current.getTimezoneOffset() / 60);
    if (value === 'lastHour') {
      current.setHours(current.getHours() - 1);
      setReadDateFrom(current.toISOString().substring(0, 19).replace('T', ' '));
      current.setHours(current.getHours() + 1);
      setReadDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    } else if (value === 'today') {
      setReadDateFrom(current.toISOString().substring(0, 10) + ' 00:00:00');
      setReadDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    } else if (value === 'yesterday') {
      current.setDate(current.getDate() - 1);
      setReadDateFrom(current.toISOString().substring(0, 10) + ' 00:00:00');
      setReadDateTo(current.toISOString().substring(0, 10) + ' 23:59:59');
    } else if (value === 'lastWeek') {
      const currentFrom = new Date();
      currentFrom.setDate(current.getDate() - 7);
      setReadDateFrom(currentFrom.toISOString().substring(0, 10) + ' 00:00:00');
      setReadDateTo(current.toISOString().substring(0, 19).replace('T', ' '));
    }
  };

  function transform(mostReads: MostRead) {
    return mostReads.data.map((r) => transformResource(r));
  }

  function handleButtons(value: any) {
    if (value.target.value === 'sve') {
      setBtn(btnEnu[0]);
      setButtonValue('1,3,4,5,184');
    } else if (value.target.value === 'vijesti') {
      setBtn(btnEnu[1]);
      setButtonValue('1');
    } else if (value.target.value === 'sport') {
      setBtn(btnEnu[2]);
      setButtonValue('3');
    } else if (value.target.value === 'showbiz') {
      setBtn(btnEnu[3]);
      setButtonValue('4');
    } else if (value.target.value === 'lifestyle') {
      setBtn(btnEnu[4]);
      setButtonValue('5');
    } else if (value.target.value === 'sci-tech') {
      setBtn(btnEnu[5]);
      setButtonValue('184');
    }
  }

  return (
    <>
      <div style={{ display: 'none', wordBreak: 'break-all' }}>EVO ROKI{JSON.stringify(process.env)}</div>
      <div className="homePage" style={{ backgroundColor: '#f0f2f5' }}>
        <div style={{ display: 'none', flexDirection: 'column' }}>
          <div style={{ background: 'orange', color: 'white', fontSize: '20px', padding: '20px' }}>
            <p>Samo PROVJERITI</p>
            <ul>
              <li>CIJENE smrtovnica</li>
              <li>REKLAME, Jedileri,Bakije i Pokop ( da li prikazati )</li>
              <li>STATUS kroz CMS</li>
            </ul>
          </div>
        </div>
        {/* <div className="leftSide">
          <div className="vSeperator"></div>
          <div className="secondRow">
            <div className="topContent">
              <p>Najčitanije</p>

              <div className="btns">
                <button
                  className={btn === btnEnu[0] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="sve"
                >
                  sve
                </button>
                <button
                  className={btn === btnEnu[1] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="vijesti"
                >
                  vijesti
                </button>
                <button
                  className={btn === btnEnu[2] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="sport"
                >
                  sport
                </button>
                <button
                  className={btn === btnEnu[3] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="showbiz"
                >
                  showbiz
                </button>
                <button
                  className={btn === btnEnu[4] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="lifestyle"
                >
                  lifestyle
                </button>
                <button
                  className={btn === btnEnu[5] ? 'btnWhite mbtn active-button' : 'btnWhite mbtn'}
                  onClick={handleButtons}
                  value="sci-tech"
                >
                  tehnologija
                </button>
              </div>
              <Select
                defaultValue="lastHour"
                style={{
                  width: 150,
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  marginRight: 24,
                }}
                onChange={onReadDateChange}
              >
                <Option value="lastHour">{t('article:lastHour')}</Option>
                <Option value="today">{t('article:today')}</Option>
                <Option value="yesterday">{t('article:yesterday')}</Option>
                <Option value="lastWeek">{t('article:lastWeek')}</Option>
              </Select>
            </div>
            <div className="bottomContent">
              <Row gutter={[8, 16]}>
                <Table
                  bordered
                  sticky
                  size="middle"
                  loading={isLoading || isFetching}
                  dataSource={transform(mostReads)}
                  pagination={false}
                >
                  <Column key="title" dataIndex="title" title={t('article:title')} filterSearch />
                  <Column key="category" width={150} dataIndex="category" title={t('article:category')} filterSearch />

                  <Column key="author" width={150} dataIndex="author" title={t('article:Author')} filterSearch />
                  <Column
                    key="numberOfHits"
                    width={100}
                    dataIndex="numberOfHits"
                    title={t('article:numberOfHits')}
                    filterSearch
                  />
                </Table>
              </Row>
            </div>
          </div>
          <div className="vSeperator"></div>
        </div>
        <div className="hSeparator"></div> */}
      </div>
    </>
  );
};
